import { UseLoading } from "@/common/composition/loading";
import { SharedState } from "@/common/state";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import { create_tree_by, isNotEmpty, once } from "@/fp";
import { computed, ref, Ref } from "@vue/composition-api";
import { MipLabel } from "../../data/model";
import * as api from "./api";

const labels: Ref<MipLabel[][]> = ref([]);
const file_url = ref("");
const [is_loading, set_loading] = UseLoading(false).as_arr();

const selected_label_id = ref("");

const can_user_submit = computed(
  () => isNotEmpty(selected_label_id.value) && isNotEmpty(file_url.value)
);

const group_lonely_items_reducer = (acc: MipLabel[][], items: MipLabel[]) => {
  if (items.length === 1) {
    acc[0].push(items[0]);
  } else {
    acc.push(items);
  }
  return acc;
};

const get_mip_labels = async (): Promise<{
  all: MipLabel[][];
  native: MipLabel[][];
}> => {
  const res = await api.getMipLabelsTree();
  if (res.success) {
    const { labels, is_empty /* , missing */ } = res.value;
    if (is_empty) {
      return { all: [], native: [] };
    } else {
      const make_tree = create_tree_by<MipLabel>("labelId", "parentId");
      const only_mip_labels = labels.filter(
        (l: MipLabel) => !SharedState.getInfoType(l.mappedLabelId)
      );
      // @ts-ignore
      const tree = make_tree(labels).map((item) => item.flat(1));

      const only_native_mip_labels_tree = make_tree(
        only_mip_labels
      ).map((item) => item.flat(1));

      return { all: tree, native: only_native_mip_labels_tree };
    }
  }
  return { all: [], native: [] };
};

const submit = async () => {
  console.log("submitting : ", file_url.value, selected_label_id.value);

  const res = await api.apply_manual_label({
    file_url: file_url.value,
    label_id: selected_label_id.value,
  });
  if (res.success) {
    UseToast().show({
      type: ToastType.SUCCESS,
      msg: "Successfully applied the label",
    });
  } else {
    UseToast().show({
      type: ToastType.ALERT,
      msg: "Failed to apply the label",
    });
  }
};

const init = once(async () => {
  set_loading(true);
  const { all } = await get_mip_labels();
  labels.value = all.reduce(group_lonely_items_reducer, [[]] as MipLabel[][]);
  set_loading(false);
});

const destroy = () => {
  file_url.value = "";
  selected_label_id.value = "";
};

export const state = {
  init,
  labels,
  file_url,
  selected_label_id,
  can_user_submit,
  submit,
  is_loading,
  destroy,
};
